import {ReactNode} from 'react';

export enum Pages {
    main = 1,
    list = 2,
    details = 3
}
export interface XpertItem {
    id: string;
    text: string;
    fileUrl?: string;
}

export enum DocType {
    FAQ = 'FAQ',
    Document = 'Document',
    Video = 'Video'
}

export type FormHelp = {
    faqs: XpertItem[];
    documents: XpertItem[];
    videos: XpertItem[];
    text: {
        text: string;
        linkData: any[];
        onLinkClick: any;
    };
    helpContent?: ReactNode;
    hasXpertError?: boolean;
};

export type FormHelpPageState = {
    page: Pages;
    docType?: DocType;
    id?: string;
    activePage?: number;
    query?: string;
};
